import React from "react";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import etlBg from "../../assets/images/etl_bg.png";

const PREFIX = "HowItWorks";

const classes = {
  contentBox: `${PREFIX}-contentBox`,
  wrapper: `${PREFIX}-wrapper`,
  techLogTitle: `${PREFIX}-techLogTitle`,
  techlogContent: `${PREFIX}-techlogContent`,
  howItWorksTitle: `${PREFIX}-howItWorksTitle`,
  howItWorksContent: `${PREFIX}-howItWorksContent`,
  howItWorksContainer: `${PREFIX}-howItWorksContainer`,
  divider: `${PREFIX}-divider`,
  iframeContainer: `${PREFIX}-iframeContainer`,
  iframe: `${PREFIX}-iframe`,
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.techLogTitle}`]: {
    color: "white",
    fontFamily: "AvenirLTStd-Roman",
    marginBottom: "3%",
    textAlign: "center",
  },
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1%",
  },
  [`& .${classes.title}`]: {
    fontFamily: "AvenirLTStd-Roman",
    textAlign: "center",
    fontSize: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`& .${classes.techlogContent}`]: {
    paddingBottom: "1rem",
    fontSize: 20,
    fontWeight: 100,
    color: "white",
    fontFamily: "AvenirLTStd-Book",
    textAlign: "center",
  },
  [`& .${classes.howItWorksTitle}`]: {
    fontFamily: "AvenirLTStd-Roman",
    textAlign: "center",
    padding: "1rem",
    fontWeight: "500",
  },
  [`& .${classes.howItWorksContent}`]: {
    fontSize: 20,
    fontWeight: 100,
    color: "white",
    fontFamily: "AvenirLTStd-Book",
    textAlign: "center",
    lineHeight: "+2",
    [theme.breakpoints.up("sm")]: {
      fontSize: 14,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 20,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 20,
    },
  },
  [`&.${classes.wrapper}`]: {
    backgroundImage: `url(${etlBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: theme.spacing(4),
    textAlign: "center",
  },
  [`& .${classes.contentBox}`]: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  [`& .${classes.howItWorksContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
    },
  },
  [`& .${classes.divider}`]: {
    borderBottom: "1px solid red",
    width: "20%",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.iframeContainer}`]: {
    marginTop: "2rem",
  },
  [`& .${classes.iframe}`]: {
    borderRadius: "20px",
    maxWidth: "600px",
    width: "100%",
    height: "300px",
  },
}));

const HowItWorks = () => {
  return (
    <>
      <StyledGrid size={{ xs: 12 }} className={classes.contentBox}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} className={classes.container}>
          <Typography variant="h5" className={classes.title}>
            How It Works
          </Typography>
          <Grid className={classes.divider} />
        </Grid>
      </StyledGrid>
      <StyledGrid container className={classes.wrapper}>
        <Grid size={{ xs: 12 }}>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            className={classes.howItWorksContainer}
          >
            <Grid size={{ xs: 12 }} className={classes.howItWorksContainer}>
              <Typography className={classes.howItWorksContent} gutterBottom>
                The ETL is installed on an assigned device (EFB or separate
                device) allowing Flight, Tech, and Cabin crew to record data.
                This data is sent to the ground system in real time, providing
                AC status and information. It’s then forwarded to systems like
                MRO, Scheduling, and Crew, with two-way M&E integration per ATA
                SPEC2000 CH17 standards.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }} className={classes.iframeContainer}>
              <iframe
                src="https://www.youtube.com/embed/_0tavthjNXw"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className={classes.iframe}
              ></iframe>
            </Grid>
          </Grid>
        </Grid>
      </StyledGrid>
    </>
  );
};

export default HowItWorks;
